import { render, staticRenderFns } from "./qualification.vue?vue&type=template&id=4cf5cda8&scoped=true&"
import script from "./qualification.vue?vue&type=script&lang=js&"
export * from "./qualification.vue?vue&type=script&lang=js&"
import style0 from "./qualification.vue?vue&type=style&index=0&id=4cf5cda8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cf5cda8",
  null
  
)

export default component.exports